import { AuthApiEndpoints } from '@contracts';

export const AUTH_ENDPOINT: AuthApiEndpoints = {
  login: {
    path: 'login/',
    domain: 'core',
    version: 'v1',
  },
  setPassword: {
    path: 'auth/set-password',
    domain: 'core',
    version: 'v1',
  },
};
